<template>
  <article :class="{ ee: storeName.EE, fr: storeName.FR }" ref="bodyNode">
    <!-- <FrContainer></FrContainer> -->
    <StoreContainer></StoreContainer>
    <StoreFooter></StoreFooter>
  </article>
</template>

<script>
import StoreContainer from "./big/StoreContainer";
import StoreFooter from "./big/StoreFooter";
import { mapState } from "vuex";

export default {
  name: "store-body",
  data() {
    return {
      bodyHeight: 0,
    };
  },
  computed: {
    ...mapState("storeInfo", ["storeName"]),
  },
  components: {
    StoreContainer,
    StoreFooter,
  },
  methods: {
    sendData(data) {
      window.parent.postMessage({ ".store-body": data }, "*");
    },
    setBodyHeight() {
      this.bodyHeight = this.$refs.bodyNode.offsetHeight;
      this.sendData(this.bodyHeight);
    },
  },
  mounted() {
    setTimeout(() => {
      this.setBodyHeight();
    }, 500);
    window.onresize = () => {
      this.setBodyHeight();
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style lang="less" scoped>
article {
  &.ee {
    background-color: #f8f8f8;
  }
}
</style>
